const products = [
  {
    id: "s2fl",
    name: "S2FL",
    description: "SUV compacto con buen equipamiento ideal para uso urbano con conectividad y funciones básicas de confort y seguridad.",
    image: require("assets/images/jac/full/s2fl.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Conjunto de sistemas que equilibran seguridad activa y eficiencia de conducción para una experiencia confiable y estable.",
        caracteristics: [
          {
            title: "Motor 1.5L de 105 Cv",
            description: "Motor eficiente de 1.5 litros con 105 caballos de fuerza, ideal para rendimiento urbano y carretera."
          },
          {
            title: "Tecnología de motor VVT",
            description: "Optimiza la apertura de válvulas para mejorar el rendimiento, eficiencia de combustible y reducir emisiones contaminantes."
          },
          {
            title: "Transmisión MT / CVT",
            description: "Disponibilidad de transmisión manual o automática CVT, adaptada a diferentes estilos y necesidades de conducción."
          },
          {
            title: "ESP / HBA / HAC",
            description: "Sistemas electrónicos que ayudan a mantener estabilidad, frenado efectivo y asistencia en pendientes pronunciadas."
          },
          {
            title: "ISOFIX",
            description: "Anclajes de seguridad que permiten instalar asientos infantiles de forma sencilla, rápida y completamente segura."
          },
          {
            title: "Sensores de estacionamiento traseros",
            description: "Detectan obstáculos al retroceder y emiten alertas sonoras para facilitar maniobras en espacios reducidos."
          },
          {
            title: "Cámara de retroceso",
            description: "Muestra visión trasera en la pantalla central, brindando mayor seguridad al estacionar o maniobrar en reversa."
          },
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Tecnología y confort diseñados para mejorar la experiencia de manejo con conectividad, comodidad y funcionalidad.",
        caracteristics: [
          {
            title: "Pantalla táctil de 9”",
            description: "Centro multimedia con pantalla de 9 pulgadas que integra entretenimiento, navegación y conectividad inteligente."
          },
          {
            title: "Car Play® & Android Auto®",
            description: "Conecta smartphones para acceso directo a apps, música, navegación y llamadas mediante la pantalla del vehículo."
          },
          {
            title: "Spotify® App & Conexión WiFi",
            description: "Acceso a música en streaming mediante Spotify y conectividad WiFi para mayor entretenimiento en ruta."
          },
          {
            title: "CCS",
            description: "Control de velocidad crucero que mantiene la marcha estable, brindando confort y eficiencia en viajes largos."
          },
          {
            title: "Aire acondicionado",
            description: "Sistema de climatización que asegura confort térmico para conductor y pasajeros en cualquier condición climática."
          },
          {
            title: "Toma de 12V",
            description: "Conector práctico para cargar dispositivos electrónicos o alimentar accesorios durante viajes y uso diario."
          }
        ]
      },
      {
        title: "Equipamiento exterior",
        description: "Elementos exteriores que combinan estilo moderno, visibilidad mejorada y practicidad para todo tipo de entorno.",
        caracteristics: [
          {
            title: "DRL",
            description: "Luces diurnas LED que mejoran la visibilidad del vehículo durante el día, aumentando la seguridad vial."
          },
          {
            title: "Encendido automático de luces",
            description: "Activa los faros en condiciones de poca luz o túneles, proporcionando comodidad y seguridad al conductor."
          },
          {
            title: "Faros antiniebla",
            description: "Iluminación adicional que aumenta la visibilidad en situaciones de niebla, lluvia intensa o baja luminosidad."
          },
          {
            title: "Espejos exteriores eléctricos",
            description: "Ajustables desde el interior, ofrecen comodidad y seguridad para adaptar la visión en cada conducción."
          },
        ]
      },

    ]
  },
  {
    id: "js4",
    name: "JS4",
    description: "SUV mediano con diseño moderno, tecnología avanzada y equipamiento completo orientado al confort y seguridad.",
    image: require("assets/images/jac/full/js4.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Protección, estilo de conducción dinámico y asistencias incorporadas.",
        caracteristics: [
          {
            title: "Motor 1.5L Turbo de 147 CV",
            description: "Motor turboalimentado de 1.5 litros con 147 caballos, excelente equilibrio entre potencia, eficiencia y rendimiento."
          },
          {
            title: "Transmisión automática CVT",
            description: "Caja automática continuamente variable que ofrece suavidad en los cambios y mayor eficiencia en consumo."
          },
          {
            title: "6 Airbags",
            description: "Sistema de protección con seis airbags distribuidos estratégicamente para máxima seguridad de pasajeros y conductor."
          },
          {
            title: "ESP, HBA, HAC, BOS",
            description: "Conjunto de asistencias electrónicas que refuerzan la estabilidad, frenado y control en diferentes condiciones."
          },
          {
            title: "TPMS",
            description: "Sistema de monitoreo de presión de neumáticos que alerta sobre niveles incorrectos en tiempo real."
          },
          {
            title: "ISOFIX",
            description: "Anclajes estandarizados que permiten instalar asientos infantiles de forma segura, rápida y totalmente confiable."
          },
          {
            title: "AUTO HOLD",
            description: "Función que mantiene el vehículo detenido en pendientes o semáforos sin necesidad de mantener el freno."
          },
          {
            title: "Alarma + IMMO",
            description: "Sistema antirrobo que incluye alarma sonora e inmovilizador electrónico para mayor seguridad del vehículo."
          },
          {
            title: "Levantavidrios OneTouch con antipinzamiento",
            description: "Subida y bajada automática de ventanas con sistema antipinzamiento para evitar accidentes y mayor seguridad."
          },
          {
            title: "Aviso de cinturones de seguridad traseros desabrochados",
            description: "Alerta sonora y visual que informa cuando los pasajeros traseros no llevan colocado el cinturón de seguridad."
          },
          {
            title: "SISTEMAS PEPS, LWC, FCW, BSM, HMA",
            description: "Conjunto avanzado de asistencias electrónicas que incluyen arranque sin llave, alerta de colisión y seguridad."
          },
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Conjunto de características que aportan confort, conectividad y tecnología al espacio interno del vehículo.",
        caracteristics: [
          {
            title: "Tapizado de ecocuero y tela",
            description: "Combinación de materiales que brindan confort, resistencia y diseño atractivo en los asientos del habitáculo."
          },
          {
            title: "Aire acondicionado climatizador con salida de aire traseras",
            description: "Sistema de climatización automático que distribuye aire en todas las plazas, incluyendo salidas traseras ajustables."
          },
          {
            title: "Bluetooth ®",
            description: "Conectividad inalámbrica para llamadas manos libres y transmisión de música desde dispositivos compatibles."
          },
          {
            title: "CarPlay® & Android Auto®",
            description: "Integración completa con smartphones para navegación, llamadas, música y aplicaciones desde la pantalla central."
          },
          {
            title: "USB delantero y traseros (2)",
            description: "Puertos USB ubicados en zona delantera y trasera para carga y conexión de dispositivos electrónicos."
          },
          {
            title: "Pantalla táctil lcd 10.25’",
            description: "Amplia pantalla multimedia de 10.25 pulgadas que integra navegación, entretenimiento y funciones del vehículo."
          },
          {
            title: "Techo corredizo eléctrico",
            description: "Apertura y cierre eléctricos que permiten mayor ventilación y sensación de amplitud en el habitáculo."
          },
          {
            title: "Panel de instrumento digital",
            description: "Pantalla digital que reemplaza indicadores analógicos, mostrando información clara y configurable para el conductor."
          },
          {
            title: "Asientos calefaccionados delanteros",
            description: "Función de calefacción en los asientos delanteros para mayor confort en climas fríos o invernales."
          },
          {
            title: "Control remoto de apertura y cierre de ventanas",
            description: "Permite abrir o cerrar las ventanas del vehículo a distancia utilizando el control remoto de llaves."
          },
          {
            title: "Espejos laterales plegables automáticos",
            description: "Se pliegan automáticamente al estacionar, protegiendo los espejos y mejorando la comodidad de uso diario."
          },
        ]
      },
      {
        title: "Equipamiento exterior",
        description: "Conjunto de elementos estéticos y funcionales diseñados para mejorar estilo, seguridad y visibilidad externa.",
        caracteristics: [
          {
            title: "Llantas de aluminio bicolor",
            description: "Ruedas de aleación en diseño bicolor que aportan estilo deportivo y mayor resistencia estructural."
          },
          {
            title: "DRL LED",
            description: "Luces de circulación diurna LED que mejoran la visibilidad del vehículo durante el día aumentando seguridad."
          },
          {
            title: "Faros traseros antiniebla",
            description: "Mejoran la visibilidad trasera en condiciones de niebla o lluvia intensa, aumentando la seguridad vial."
          },
          {
            title: "Encendido automático de luces",
            description: "Sistema que enciende los faros automáticamente cuando disminuye la luz ambiental o ingresando a túneles."
          },
          {
            title: "Función “Follow me home”",
            description: "Mantiene los faros encendidos por unos segundos después de apagar el motor, iluminando el camino."
          },
          {
            title: "Espejos exteriores eléctricos y calefaccionados",
            description: "Ajustables eléctricamente y con calefacción para mayor comodidad y visibilidad en climas fríos o húmedos."
          },
          {
            title: "Sensores de estacionamiento y retroceso con Cámara 360º",
            description: "Sistema de asistencia que combina sensores perimetrales y visión de 360 grados para maniobras seguras."
          }
        ]
      }
    ]
  },
  {
    id: "JS8PRO",
    name: "JS8 Pro",
    description: "SUV de alta gama, con siete plazas, tecnología avanzada y gran comodidad para toda la familia.",
    image: require("assets/images/jac/full/js8pro.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Protección, estilo de conducción dinámico y asistencias incorporadas.",
        caracteristics: [
          {
            title: "Motor 1.5L Turbo de 182 CV",
            description: "Motor turboalimentado de 1.5 litros con 182 caballos, entrega potencia, eficiencia y excelente respuesta dinámica."
          },
          {
            title: "Tecnología de motor inyección directa",
            description: "Sistema de inyección directa que mejora rendimiento, potencia y eficiencia de combustible optimizando la combustión."
          },
          {
            title: "Transmisión automática 7DCT",
            description: "Caja automática de doble embrague con 7 velocidades, ofrece cambios rápidos y mayor eficiencia energética."
          },
          {
            title: "Sensores de estacionamiento delanteros y traseros",
            description: "Detectan obstáculos alrededor del vehículo, proporcionando alertas para facilitar maniobras seguras al estacionar."
          },
          {
            title: "6 Airbags y frenado ABS y EBD, HBA, HAC y BOS",
            description: "Sistemas de seguridad activa y pasiva que protegen ocupantes y mejoran control y frenado en emergencias."
          },
          {
            title: "ADAS (Sistemas avanzados de asistencia al conductor) ACC, AEB, FCW, BSM, LCA, DOW",
            description: "Conjunto de tecnologías que asisten al conductor en prevención de colisiones, mantenimiento de carril y conducción segura."
          },
          {
            title: "AUTO HOLD",
            description: "Mantiene el vehículo detenido automáticamente en pendientes o semáforos, liberando el freno sin esfuerzo del conductor."
          },
          {
            title: "ISOFIX",
            description: "Anclajes estandarizados para instalar sillas infantiles de manera segura, rápida y confiable en los asientos traseros."
          },
          {
            title: "Selección modo de manejo Eco, Normal, Sport, Nieve",
            description: "Permite elegir modos de conducción según eficiencia, confort, desempeño deportivo o condiciones de nieve."
          },
          {
            title: "Sistema de apertura de puertas sin llave",
            description: "Permite desbloquear y abrir puertas automáticamente sin necesidad de llave física, brindando comodidad y seguridad."
          },
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Conjunto de elementos que aportan confort, tecnología y practicidad para todos los ocupantes del vehículo.",
        caracteristics: [
          {
            title: "Capacidad de 7 pasajeros",
            description: "Espacio suficiente para siete ocupantes, combinando comodidad y distribución eficiente del interior del vehículo."
          },
          {
            title: "Techo panorámico eléctrico",
            description: "Techo corredizo panorámico que permite entrada de luz natural y ventilación controlada desde los asientos delanteros."
          },
          {
            title: "Tablero de instrumentos LCD de 12,3’’",
            description: "Pantalla digital de gran tamaño que muestra información de conducción clara, configurable y moderna."
          },
          {
            title: "Pantalla táctil 12”",
            description: "Sistema multimedia central de 12 pulgadas que integra navegación, entretenimiento, conectividad y control del vehículo."
          },
          {
            title: "Cámara 360°",
            description: "Proporciona visión completa del entorno del vehículo, facilitando maniobras de estacionamiento y seguridad perimetral."
          },
          {
            title: "Aire acondicionado climatizador con salida de aires traseras",
            description: "Sistema automático que distribuye aire de manera uniforme, incluyendo salidas traseras para máximo confort."
          },
          {
            title: "Salidas de aire en tercera fila de asientos",
            description: "Permite climatizar la tercera fila de pasajeros, garantizando comodidad para todos los ocupantes."
          },
          {
            title: "Asientos de cuero calefaccionables",
            description: "Asientos tapizados en cuero con función de calefacción para confort en climas fríos o inviernos."
          },
          {
            title: "Consola central con refrigeración",
            description: "Compartimento refrigerado en la consola central para mantener bebidas y objetos frescos durante los viajes."
          },
          {
            title: "CarPlay® & Android Auto®",
            description: "Integración completa con smartphones para música, llamadas y navegación mediante la pantalla central del vehículo."
          },
          {
            title: "USB delanteros (2)",
            description: "Puertos USB delanteros para carga de dispositivos y conectividad de smartphones en la cabina principal."
          },
          {
            title: "USB segunda fila (1 USB + 1 USB C)",
            description: "Puertos ubicados en la segunda fila para carga rápida de dispositivos de pasajeros traseros, incluyendo USB-C."
          },
          {
            title: "USB tercera fila (1)",
            description: "Puerto USB para que los pasajeros de la tercera fila puedan cargar dispositivos cómodamente."
          },
        ]
      },
      {
        title: "Equipamiento exterior",
        description: "Conjunto de elementos que aportan estilo, funcionalidad y seguridad al exterior del vehículo.",
        caracteristics: [
          {
            title: "Portón trasero eléctrico de fácil apertura",
            description: "Apertura eléctrica del portón trasero que facilita carga y descarga sin esfuerzo manual."
          },
          {
            title: "Faros traseros y delanteros LED",
            description: "Iluminación LED eficiente y duradera que mejora visibilidad, seguridad y estética del vehículo."
          },
          {
            title: "Faros antiniebla traseros",
            description: "Mejoran la visibilidad trasera en condiciones de niebla o lluvia intensa para mayor seguridad vial."
          },
          {
            title: "Encendido automático de luces",
            description: "Activa los faros automáticamente ante poca luz, túneles o anochecer, mejorando comodidad y seguridad."
          },
          {
            title: "Espejos exteriores eléctricos, calefaccionables y plegables automáticamente",
            description: "Ajuste eléctrico, calefacción y plegado automático de espejos para mayor comodidad, visibilidad y protección."
          }
        ]
      }
    ]
  },
  {
    id: "x200",
    name: "X200",
    description: "Utilitario práctico, seguro y económico, ideal para uso comercial con buen equipamiento básico.",
    image: require("assets/images/jac/full/x200.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Motor resistente, doble airbag y características de seguridad para uso comercial.",
        caracteristics: [
          {
            title: "2.0 L Common Rail Turbo Diesel Intercooler de 136 Cv",
            description: "Motor diésel eficiente con turbo e intercooler, ofrece 136 CV y buen rendimiento en todo terreno."
          },
          {
            title: "Bajo consumo de combustible",
            description: "Optimiza el gasto de combustible, ofreciendo mayor autonomía y eficiencia en viajes urbanos y largos."
          },
          {
            title: "Confiable y de mantenimiento económico",
            description: "Diseñado para durar con costos de mantenimiento bajos, ideal para trabajo intensivo y uso diario."
          },
          {
            title: "FPS",
            description: "Sistema de protección adicional que brinda mayor seguridad al conductor y pasajeros en distintas condiciones."
          },
          {
            title: "Doble airbag delantero",
            description: "Proporciona seguridad extra a conductor y acompañante en caso de colisiones frontales fuertes."
          },
        ]
      },
      {
        title: "Equipamiento",
        description: "Elementos que agregan funcionalidad exterior en uso comercial.",
        caracteristics: [
          {
            title: "Aire acondicionado",
            description: "Mantiene la temperatura interior agradable, garantizando confort en todas las condiciones climáticas."
          },
          {
            title: "Dirección asistida hidráulicamente",
            description: "Facilita la maniobrabilidad del vehículo reduciendo el esfuerzo al girar en cualquier situación."
          },
          {
            title: "Bluetooth",
            description: "Conexión inalámbrica para llamadas y música, ofreciendo comodidad y seguridad al conducir."
          },
          {
            title: "Volante multifunción regulable en altura",
            description: "Permite ajustar la altura y controlar funciones sin soltar el volante, aumentando la ergonomía."
          },
          {
            title: "Levantavidrios eléctrico",
            description: "Accionamiento eléctrico de ventanillas para comodidad del conductor y acompañantes en cualquier situación."
          },
          {
            title: "Espejos exteriores eléctricos y calefaccionados",
            description: "Ajustables desde el interior y con calefacción para mejor visibilidad en climas fríos."
          },
          {
            title: "USB",
            description: "Puerto de conexión para cargar dispositivos móviles y reproducir música directamente en el vehículo."
          },
          {
            title: "Rueda de auxilio tamaño original",
            description: "Ofrece respaldo confiable con una rueda igual a las principales para emergencias en ruta."
          },
        ]
      },
      {
        title: "Practicidad",
        description: "Capacidad de carga y usos comerciales con diseño adaptado.",
        caracteristics: [
          {
            title: "Caja de carga, facilita el acceso",
            description: "Espacio trasero amplio y accesible diseñado para transportar cargas de forma práctica y cómoda."
          },
          {
            title: "Altura total inferior a 2m",
            description: "Dimensiones compactas que facilitan estacionar en cocheras y garajes de altura reducida."
          },
          {
            title: "Fácil mantenimiento",
            description: "Componentes accesibles y de bajo costo que simplifican las tareas de mantenimiento periódico."
          },
          {
            title: "Sensores de estacionamiento traseros",
            description: "Ayudan al conductor a maniobrar en reversa con alertas de proximidad para mayor seguridad."
          },
          {
            title: "CCS",
            description: "Sistema de control avanzado que mejora la estabilidad y seguridad en distintas condiciones de manejo."
          },
          {
            title: "Capacidad de carga 1.500kg",
            description: "Soporta grandes volúmenes de peso, ideal para transporte comercial o trabajos intensivos."
          }
        ]
      },
    ]
  },
  {
    id: "t8",
    name: "T8",
    description: "Pick-up robusta con capacidad de carga alta, tracción 4×4, ideal para trabajo exigente con confort moderno.",
    image: require("assets/images/jac/full/t8.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Componentes mecánicos y electrónicos pensados para trabajar con fiabilidad y seguridad.",
        caracteristics: [
          {
            title: "Motor 2.0 L Common Rail + Turbo + Intercooler de 139 CV + DPF",
            description: "Motor diésel potente y eficiente con turbo e intercooler, cumple normas de emisiones gracias al filtro DPF."
          },
          {
            title: "Tracción 4x4",
            description: "Sistema de tracción integral que mejora el desempeño y estabilidad en terrenos exigentes y condiciones adversas."
          },
          {
            title: "ESC / ABS / HBA / BOS / EBD / HHC / TCS / VDC",
            description: "Conjunto de sistemas electrónicos que mejoran la estabilidad, frenado y control en diversas condiciones de conducción."
          },
          {
            title: "Frenos a disco en las cuatro ruedas",
            description: "Mayor capacidad de frenado y seguridad, gracias a discos en las cuatro ruedas del vehículo."
          },
          {
            title: "Control de presión de neumáticos",
            description: "Monitorea el aire de los neumáticos en tiempo real, brindando mayor seguridad y eficiencia en ruta."
          },
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Conjunto de elementos que garantizan confort, tecnología y practicidad para conductor y pasajeros.",
        caracteristics: [
          {
            title: "Pantalla táctil 9¨ + Bluetooth",
            description: "Sistema multimedia con pantalla de 9 pulgadas y conectividad Bluetooth para entretenimiento y comunicación."
          },
          {
            title: "Tapizado de ecocuero",
            description: "Material resistente y elegante que combina durabilidad, estilo y fácil mantenimiento en el interior del vehículo."
          },
          {
            title: "Dirección asistida hidráulicamente",
            description: "Facilita la conducción reduciendo el esfuerzo necesario para maniobrar, especialmente en espacios reducidos."
          },
          {
            title: "Espejos eléctricos con luz de giro",
            description: "Espejos ajustables desde el interior con señal de giro integrada para mayor seguridad y visibilidad."
          },
          {
            title: "Faros regulables en altura",
            description: "Permiten ajustar manualmente el ángulo de iluminación según la carga y condiciones de la ruta."
          },
          {
            title: "Sensores de estacionamiento traseros",
            description: "Detectan obstáculos al retroceder y emiten alertas sonoras para facilitar el estacionamiento seguro."
          },
          {
            title: "Cámara de retroceso",
            description: "Proporciona visión trasera en pantalla central, facilitando maniobras de estacionamiento y marcha atrás."
          },
          {
            title: "Volante multifunción regulable en altura",
            description: "Permite controlar funciones del vehículo y ajustar la altura para mayor comodidad del conductor."
          },
          {
            title: "CCS (Control de Velocidad Crucero)",
            description: "Mantiene automáticamente la velocidad seleccionada en ruta, brindando comodidad y eficiencia en viajes largos."
          },
          {
            title: "Keyless entry / Start button",
            description: "Permite acceder y encender el vehículo sin usar llave física, aumentando practicidad y seguridad."
          },
          {
            title: "Apple Carplay® & Android Auto®",
            description: "Integración de smartphones para navegación, música y llamadas a través de la pantalla central del vehículo."
          },]
      },
      {
        title: "Equipamiento exterior",
        description: "Diseño y accesorios exteriores pensados para robustez, funcionalidad y una imagen moderna en todo terreno.",
        caracteristics: [
          {
            title: "Revestimiento epoxi de caja de carga",
            description: "Protección especial que aumenta la durabilidad de la caja de carga contra golpes y corrosión."
          },
          {
            title: "Faros antiniebla",
            description: "Mejoran la visibilidad en condiciones de niebla, lluvia o baja luminosidad, aumentando la seguridad al conducir."
          },
          {
            title: "Estribos laterales",
            description: "Facilitan el ingreso y egreso del vehículo, además de aportar un estilo más robusto."
          },
          {
            title: "Barra antivuelco",
            description: "Estructura adicional que protege en caso de vuelco y aporta un diseño más resistente."
          },
          {
            title: "Capacidad de carga 900kg",
            description: "Permite transportar cargas pesadas de hasta 900 kg, ideal para uso laboral e intensivo."
          },
        ]
      },
    ]
  }
];

export default products;
